export class SubirArchivos_Usuario {
    id: number;
    ruta: string;
    descripcion: string;
    subirArchivo: boolean;
    eliminar: boolean;
    subdirectorios: boolean;
    activo: boolean;
    filtroArchivos: string;
    listaDirectorios: SubirArchivos_Usuario_Directorios[];
}

export class SubirArchivos_Usuario_Directorios {
    ruta: string;
    descripcion: string;
    rutaPadre: string;
    descripcionRuta: string;
    tieneSubDirectorios: boolean;
}

export class SubirArchivos_Usuario_Archivos {
    nombreArchivo: string;
    fecha: Date;
    esDirectorio: boolean;
}

export class SubirArchivos_Usuario_Archivos_Seleccionados {
    itemDirectorio: SubirArchivos_Usuario_Directorios;
    listaArchivos: SubirArchivos_Usuario_Archivos[];
}